import React from 'react';
import { CTAButton } from './CTAButton';
import { Shield } from 'lucide-react';
export function FinalCTA() {
  return <section className="bg-navy text-white py-20 px-4 text-center border-t-8 border-patriot-red" data-id="element-84">
      <div className="max-w-3xl mx-auto" data-id="element-85">
        <h2 className="text-3xl md:text-5xl font-bold mb-6 leading-tight" data-id="element-86">
          Get the entire <span className="text-gold" data-id="element-87">$95.94</span> Patriot
          Bundle today for just <span className="text-gold" data-id="element-88">$29.97</span>.
        </h2>

        <p className="text-xl text-blue-200 mb-10 max-w-2xl mx-auto" data-id="element-89">
          This is a limited-time offer to equip as many patriots as possible
          before the next cultural shift. Instant digital delivery.
        </p>

        <div className="max-w-md mx-auto mb-6" data-id="element-90">
          <CTAButton data-id="element-91">UNLOCK THE PATRIOT BUNDLE NOW — $29.97</CTAButton>
        </div>

        <div className="flex items-center justify-center gap-2 text-gray-400 text-sm" data-id="element-92">
          <Shield size={16} data-id="element-93" />
          <span data-id="element-94">Join 12,000+ patriots today. Instant delivery via email.</span>
        </div>
      </div>
    </section>;
}